import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"}
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#7D818A",
      d: "M1.75 11.083h10.5v1.167H1.75zm5.833-3.4 3.542-3.541.825.825L7 9.917l-4.95-4.95.825-.825 3.542 3.54V1.168h1.166z"
    }, null, -1)
  ]))]))
}
export default { render: render }